module.exports = "label {\n  font-size: .7em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-personal-achievements/achievement-files/achievement-file-add/achievement-file-add.component.scss
// module id = ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-personal-achievements/achievement-files/achievement-file-add/achievement-file-add.component.scss
// module chunks = main